<template>
  <div class="active">
    <div class="my-chard">
      <!-- 图1 -->
      <el-card shadow="never" class="chard-box fris">
        <!-- 顶部区域 -->
        <div class="fl">
          <img
            src="../../../assets/images/newIcon/vipportrait_day_icon@2x.png"
            alt=""
          />
          <span></span><b style="font-weight:500;">活跃用户趋势</b>
        </div>
        <span class="text">2021.06.18 ～ 2021.07.2近30日活跃用户趋势</span>
        <div class="linephoto">
          <!-- 数字区域 -->
          <div class="mian">
            <!-- 左侧数字 -->
            <div class="lnum">
              <div class="m2">
                <span style="font-size: 14px"> &nbsp7-28 &nbsp&nbsp(三)</span>
                <span style="font-size: 43px; font-weight: bold"
                  >319<span style="font-size: 12px">人</span>
                </span>
              </div>
              <div class="m3">
                <span style="font-size:12px;"
                  >环比
                  <span
                    style="color: #ff4343; font-size: 12px; font-weight: 600"
                    >5.9%</span
                  ><i
                    style="color: #ff4343; font-weight: 600"
                    class="el-icon-top"
                  ></i
                ></span>
                <span style="font-size:12px;"
                  >同比
                  <span
                    style="color: #19e9aa; font-size: 12px; font-weight: 600"
                    >5.9%</span
                  ><i
                    style="color: #19e9aa; font-weight: 600"
                    class="el-icon-bottom"
                  ></i
                ></span>
              </div>
            </div>
            <!-- 右侧数字 -->
            <div class="rnum">
              <p class="bigsize">
                <span class="smallsize" style="font-size:12px;">合计：</span>
                <span class="fz28">31,123</span>
                <span class="smallsize" style="font-size:12px;">人</span>
              </p>
              <p class="bigsize">
                <span class="smallsize" style="font-size:12px;">均值：</span
                ><span class="fz28">31,123</span
                ><span class="smallsize" style="font-size:12px;">人</span>
              </p>
            </div>
          </div>
          <div id="b1" style="width: 850px;height:300px;margin-top: 50px;margin-left:30px;"></div>
        </div>
      </el-card>
      <!-- 图2 -->
      <el-card shadow="never" class="chard-box">
        <!-- 顶部区域 -->
        <div class="fl">
          <img
            src="../../../assets/images/newIcon/activeanalysis_proportion_icon@2x.png"
            alt=""
          />
          <span></span><b style="font-weight:500;">新用户占比趋势</b>
        </div>
        <span class="text">2021.06.18 ～ 2021.07.20近30日新用户活跃占比</span>
        <!-- 数字区域 -->
        <div class="mian">
          <!-- 左侧数字 -->
          <div class="lnum">
            <div class="m2">
              <span style="font-size: 14px"> &nbsp7-27 &nbsp&nbsp(二)</span>
              <span style="font-size: 43px; font-weight: bold"
                >26.2<span style="font-size: 12px;display:inline-block; transform: translate(0px, -14px);">%</span>
              </span>
            </div>
            <div class="m3">
              <span style="font-size:12px;"
                >环比
                <span style="color: #ff4343; font-size: 12px; font-weight: 600"
                  >5.9%</span
                ><i
                  style="color: #ff4343; font-weight: 600"
                  class="el-icon-top"
                ></i
              ></span>
              <span style="font-size:12px;"
                >同比
                <span style="color: #19e9aa; font-size: 12px; font-weight: 600"
                  >5.9%</span
                ><i
                  style="color: #19e9aa; font-weight: 600"
                  class="el-icon-bottom"
                ></i
              ></span>
            </div>
          </div>
          <!-- 右侧数字 -->
          <div class="rnum">
            <p class="bigsize">
              <span class="smallsize">合计：</span>31,123<span class="smallsize"
                >%</span
              >
            </p>
            <p class="bigsize">
              <span class="smallsize">均值：</span>31,123<span class="smallsize"
                >%</span
              >
            </p>
          </div>
        </div>
        <div id="b2" style="margin-top: 20px"></div>
      </el-card>
      <!-- 图3 -->
      <el-card shadow="never" class="chard-box">
        <div class="top6 clearfix">
          <div class="fl">
            <img
              src="../../../assets/images/newIcon/activeanalysis_active_icon.png"
              alt=""
            />
            <span></span><b style="font-weight:500;">新用户活跃结构数量</b
            ><span class="text"></span>
          </div>
          <!-- 右侧区域 -->
          <div class="fr">
            <p>
              <img
                src="../../../assets/images/newIcon/ss_shaixuan_icon.png"
                alt=""
              />
              <el-select
                style="width: 100px"
                v-model="options1.value"
                placeholder="请选择"
                class="my-select"
              >
                <el-option
                  v-for="item in options1"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </p>
          </div>
        </div>
        <p style="color: #333; font-size: 12px; margin-top: 10px">
          2021.06.18 ～ 2021.07.20近30日新用户活跃占比
        </p>
        <!-- 数字日期区域 -->
        <div class="numDate">
          <p class="date" style="font-size:14px;">7-27 (二)</p>
          <div class="num">
            <div class="left">
              <span class="popBar"></span><span style="font-size:12px;">新增用户-没有下单行为</span>
              <p class="blueColor fz43" style="margin-top:5px; font-weight:bold;">319<span class="fz12" style="font-weight:400;">人</span></p>
            </div>
            <div class="right">
              <span class="buleBar"></span><span style="font-size:12px;">新增用户-有下单行为</span>
              <p class="blueColor fz43" style="margin-top:5px; font-weight:bold;">319<span class="fz12" style="font-weight:400;">人</span></p>
            </div>
          </div>
        </div>
        <div id="b3" style="margin-top: 20px"></div>
      </el-card>
      <!-- 图4 -->
      <el-card shadow="never" class="chard-box">
        <!-- 顶部区域 -->
        <div class="fl">
          <img
            src="../../../assets/images/newIcon/vipportrait_day_icon@2x.png"
            alt=""
          />
          <span></span><b style="font-weight:500;">周活跃客户</b>
        </div>
        <span class="text">2021.06.18 ～ 2021.07.20近60日周活跃客户</span>
        <!-- 数字区域 -->
        <div class="mian">
          <!-- 左侧数字 -->
          <div class="lnum">
            <div class="m2">
              <span style="font-size: 14px; font-weight: 500; ">本周</span>
              <span style="font-size: 43px; font-weight: bold"
                >319<span style="font-size: 12px;font-weight: 400">人</span>
              </span>
            </div>
            <div class="m3">
              <span style="font-size:12px;"
                >环比 
                <span style="color: #ff4343; font-size: 12px; font-weight: 600"
                  >5.9%</span
                ><i
                  style="color: #ff4343; font-weight: 600"
                  class="el-icon-top"
                ></i
              ></span>
              <span style="font-size:12px;"
                >同比
                <span style="color: #19e9aa; font-size: 12px; font-weight: 600"
                  >5.9%</span
                ><i
                  style="color: #19e9aa; font-weight: 600"
                  class="el-icon-bottom"
                ></i
              ></span>
            </div>
          </div>
          <!-- 右侧数字 -->
          <div class="rnum">
            <p class="bigsize">
              <span class="smallsize">合计：</span>31,12<span class="smallsize"
                >万人</span
              >
            </p>
            <p class="bigsize">
              <span class="smallsize">均值：</span>31,123<span class="smallsize"
                >人</span
              >
            </p>
          </div>
        </div>
        <div id="b4" style="margin-top: 20px"></div>
      </el-card>
      <!-- 图5 -->
      <el-card shadow="never" class="chard-box">
        <!-- 顶部区域 -->
        <div class="fl">
          <img
            src="../../../assets/images/newIcon/vipportrait_day_icon@2x.png"
            alt=""
          />
          <span></span><b style="font-weight:500;">月活跃客户</b>
        </div>
        <span class="text">2021.06 ～ 2021.07月活跃客户分析</span>
        <!-- 数字区域 -->
        <div class="mian">
          <!-- 左侧数字 -->
          <div class="lnum">
            <div class="m2">
              <span style="font-size: 14px;font-weight: 500; ">本月</span>
              <span style="font-size: 43px; font-weight: bold"
                >319<span style="font-size: 12px;font-weight: 400">人</span>
              </span>
            </div>
            <div class="m3">
              <span style="font-size:12px;"
                >环比
                <span style="color: #ff4343; font-size: 12px; font-weight: 600"
                  >5.9%</span
                ><i
                  style="color: #ff4343; font-weight: 600"
                  class="el-icon-top"
                ></i
              ></span>
              <span style="font-size:12px;"
                >同比
                <span style="color: #19e9aa; font-size: 12px; font-weight: 600"
                  >5.9%</span
                ><i
                  style="color: #19e9aa; font-weight: 600"
                  class="el-icon-bottom"
                ></i
              ></span>
            </div>
          </div>
          <!-- 右侧数字 -->
          <div class="rnum">
            <p class="bigsize">
              <span class="smallsize">合计：</span>31,12<span class="smallsize"
                >万人</span
              >
            </p>
            <p class="bigsize">
              <span class="smallsize">均值：</span>31,123<span class="smallsize"
                >人</span
              >
            </p>
          </div>
        </div>
        <div id="b5" style="margin-top: 20px"></div>
      </el-card>
    </div>
  </div>
</template>
<script>
import { registerTheme, Chart } from "@antv/g2";
export default {
  data() {
    return {
      options1: [{ name: "7月" }],
      data: [
        { data: "6.21", name: "新用户占比", val: 120 },
        { data: "6.22", name: "新用户占比", val: 750 },
        { data: "6.23", name: "新用户占比", val: 270 },
        { data: "6.24", name: "新用户占比", val: 280 },
        { data: "6.25", name: "新用户占比", val: 850 },
        { data: "6.26", name: "新用户占比", val: 150 },
        { data: "6.27", name: "新用户占比", val: 700 },
        { data: "6.28", name: "新用户占比", val: 140 },
        { data: "6.29", name: "新用户占比", val: 120 },
        { data: "...", name: "新用户占比", val: 130 },
      ],
      data2:[
        { data: "6.21", name: "活跃客户数量", val: 120 },
        { data: "6.22", name: "活跃客户数量", val: 750 },
        { data: "6.23", name: "活跃客户数量", val: 270 },
        { data: "6.24", name: "活跃客户数量", val: 280 },
        { data: "6.25", name: "活跃客户数量", val: 850 },
        { data: "6.26", name: "活跃客户数量", val: 150 },
        { data: "6.27", name: "活跃客户数量", val: 700 },
        { data: "6.28", name: "活跃客户数量", val: 140 },
        { data: "6.29", name: "活跃客户数量", val: 120 },
        { data: "...", name: "活跃客户数量", val: 130 },
      ],

    };
  },
  mounted() {
    //图1
    this.init("b1", this.data,300);
    //图2
    this.init("b2", this.data);
    // 图3
    this.init3("b3");
    // 图4
    this.init("b4", this.data2);
    // 图5
    this.init("b5", this.data2);
  },
  methods: {
    //线图
    init(id, data, height) {
      const chart = new this.$chart({
        container: id,
        autoFit: true,
        height: height || 300,
      });
      // chart
      // .interval({
      //     theme: {
      //     defaultColor: 'red',
      //     },
      // })
      // .position(0);
      chart.data(data);
      chart.scale({
        month: {
          range: [0, 1],
        },
        temperature: {
          nice: true,
        },
      });
      chart.scale("val", {
        min: 0,
        max: 1000,
      });
      chart.tooltip({
        showCrosshairs: false,
        shared: true,
        showMarkers: true,
      });
      chart.axis("val", {
        label: {
          formatter: (val) => {
            return val;
          },
        },
      });

      chart.line().position("data*val").shape("smooth").color("name");

      // chart.point().position("data*val").shape("circle");

      chart.render();
    },
    //线柱图
     init3(id) {
      const data1 = [

         { type: "新客户人均启动次数", name: "6.28", value: 50 },
        { type: "新客户人均启动次数", name: "6.30", value: 900 },
        { type: "新客户人均启动次数", name: "7.2",  value: 400 },
        { type: "新客户人均启动次数", name: "7.4",  value: 550 },
        { type: "新客户人均启动次数", name: "7.6",  value: 350 },
        { type: "新客户人均启动次数", name: "7.8",  value:  150},
        { type: "新客户人均启动次数", name: "7.10", value:  750},
        { type: "新客户人均启动次数", name: "7.12", value: 800 },
        { type: "新客户人均启动次数", name: "7.14", value: 450 },
        { type: "新客户人均启动次数", name: "7.16", value:  600},
        { type: "新客户人均启动次数", name: "7.18", value: 750 },
        { type: "新客户人均启动次数", name: "7.20", value: 1000 },
        { type: "新客户人均启动次数", name: "7.22", value:  750},

        { type: "老客户人均启动次数", name: "6.28", value: 800 },
        { type: "老客户人均启动次数", name: "6.30", value: 900 },
        { type: "老客户人均启动次数", name: "7.2",  value: 400 },
        { type: "老客户人均启动次数", name: "7.4",  value: 550 },
        { type: "老客户人均启动次数", name: "7.6",  value: 50 },
        { type: "老客户人均启动次数", name: "7.8",  value:  750},
        { type: "老客户人均启动次数", name: "7.10", value: 750 },
        { type: "老客户人均启动次数", name: "7.12", value: 800 },
        { type: "老客户人均启动次数", name: "7.14", value: 450 },
        { type: "老客户人均启动次数", name: "7.16", value:  80},
        { type: "老客户人均启动次数", name: "7.18", value:  750},
        { type: "老客户人均启动次数", name: "7.20", value: 250 },
        { type: "老客户人均启动次数", name: "7.22", value:  770},

       
        
      ];
        const data2 = [  
        { type: "整体人均启动次数", name: "6.28",value:890 },
        { type: "整体人均启动次数", name: "6.30",value:1840 },
        { type: "整体人均启动次数", name: "7.2", value:840 },
        { type: "整体人均启动次数", name: "7.4", value:1140 },
        { type: "整体人均启动次数", name: "7.6", value:450 },
        { type: "整体人均启动次数", name: "7.8", value:940 },
        { type: "整体人均启动次数", name: "7.10",value:1540 },
        { type: "整体人均启动次数", name: "7.12",value:1640 },
        { type: "整体人均启动次数", name: "7.14",value:940 },
        { type: "整体人均启动次数", name: "7.16",value: 730},
        { type: "整体人均启动次数", name: "7.18",value: 1540},
        { type: "整体人均启动次数", name: "7.20",value: 1290},
        { type: "整体人均启动次数", name: "7.22",value:1560 },]

      const data = [...data1,...data2]
      const chart = new Chart({
        container: id,
        autoFit: true,
        height: 250,
        });
    //设置Y轴的最大最小值
  chart.scale("value", {
        min: 0,
        max: 2000,
      });
      chart.data(data);
      chart.tooltip({
        shared: true,
        showMarkers: false,
      });

      chart.data(data)

      const view1 = chart.createView();
      view1.data(data1);
      if(id == 'b3'){
        view1
        .interval()
        .position("name*value")
        .color("type",['#C185F6','#5B6FF9','#657693'])
        .adjust("stack");
      }else{
        view1
        .interval()
        .position("name*value")
        .color("type",['#5B6FF9','#44D7B6','#657693'])
        .adjust("stack");
      }

      const view2 = chart.createView();
      view2.data(data2);

      view2.line().position("name*value").shape("dot").color("type",['#657693']);
      view2.point().position("name*value").shape("circle").color("type",['#657693']);
      // chart.interaction("active-region");
      if( id == 'b3'){
            chart.legend({
        custom: true,
          items: [
          {
            name: '新客户人均启动次数',
            id: 'new',
            marker:{ symbol: 'square',style:{fill:'#5B6FF9'}}  
          },
          {
            name: '老客户人均启动次数',
            id: 'old',
            marker:{symbol: 'square',style:{fill:'#C185F6'}}  
          },
          {
            name: '整体人均启动次数',
            id: 'sum',
           marker:{symbol: 'square',style:{fill:'#657693'}}  
          },
  ],
});
      }else{
              chart.legend({
        custom: true,
          items: [
          {
            name: '新客户人均启动次数',
            id: 'new',
            marker:{symbol: 'square',style:{fill:'#5B6FF9'}}  
          },
          {
            name: '老客户人均启动次数',
            id: 'old',
            marker:{symbol: 'square',style:{fill:'#44D7B6'}}  
          },
          {
            name: '整体人均启动次数',
            id: 'sum',
           marker:{symbol: 'square',style:{fill:'#657693'}}  
          },
  ],
});
      }
      chart.render();
    }
  },
};
</script>
<style lang="less">
.active {
  .bigsize {
    font-size: 28px;
    font-weight: 500;
  }
  .smallsize {
    font-size: 12px;
    font-weight: normal;
  }
  .my-chard {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .chard-box {
      margin-top: 20px;
      width: 49%;
      height: 480px;
      .fl {
        font-size: 16px;
        display: flex;
        align-items: center;
        b {
          margin-left: 10px;
        }
        img {
          width: 24px;
        }
      }
      .text {
        display: block;
        margin-left: 12px;
        color: #333;
        font-size: 12px;
        line-height: 24px;
        margin-top: 10px;
      }
      //数字样式
      .mian {
        display: flex;
        justify-content: space-between;
        .lnum {
          display: flex;
          .m2 {
            margin-left: 20px;
            margin-bottom: -5px;
            display: flex;
            flex-direction: column;
            justify-content: flex-end;
            color: #0091ff;
          }
          .m3 {
            margin-left: 20px;
            display: flex;
            flex-direction: column;
            justify-content: flex-end;
          }
        }
        .rnum {
          margin-right: 60px;
          position: relative;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          &:after {
            content: "";
            width: 2px;
            height: 40px;
            background-color: #333;
            position: absolute;
            top: 16px;
            left: -20px;
          }
        }
      }
      // 图3单独样式
      .top6 {
        margin-top: -5px;
        .fl {
          float: left;
          font-size: 16px;
          display: flex;
          b {
            margin-left: 6px;
          }
          img {
            width: 24px;
          }
          .text {
            margin-left: 12px;
            color: #333;
            font-size: 12px;
            line-height: 24px;
          }
        }
        .fr {
          float: right;
          color: #999999;
          font-size: 12px;
          p {
            img {
              width: 16px;
              vertical-align: middle;
              //   margin-right: 10px;
            }
          }
          .my-select {
            margin-left: 10px;
          }
        }
      }
      // 图3日期数字样式
      .numDate {
        margin-top: 10px;
        margin-left: 13px;
        .date {
          color: #327eff;
          margin-bottom: 10px;
        }
        .num {
          display: flex;
          justify-content: space-between;
          .right {
            margin-right: 60px;
          }
        }
      }
    }
    // 顶部图单独样式
    .fris {
      width: 98%;
      height: 430px;
      .fl {
        font-size: 16px;
        display: flex;
        align-items: center;
        b {
          margin-left: 10px;
        }
        img {
          width: 24px;
         
        }
      }
      .text {
        display: block;
        margin-left: 12px;
        color: #333;
        font-size: 12px;
        line-height: 24px;
        margin-top: 10px;
      }
      .linephoto {
        display: flex;
        justify-content: space-evenly;
        .mian {
          margin-top: 20px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          height: 200px;
          .lnum {
            display: flex;
            .m2 {
              margin-left: 20px;
              margin-bottom: -5px;
              display: flex;
              flex-direction: column;
              justify-content: flex-end;
              color: #0091ff;
            }
            .m3 {
              margin-left: 20px;
              display: flex;
              flex-direction: column;
              justify-content: flex-end;
            }
          }
          .rnum {
              margin-right: 0px;
            // margin-left: 50px;
            position: relative;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            p{
              text-align: center;
            }
            &:after {
              content: "";
              width: 150px;
              height: 1px;
              background-color: rgba(0, 0, 0, 0.15);
              position: absolute;
              top: -39px;
              left: 24px;
            }
          }
        }
      }
    }
  }
  .buleBar,
  .greBar,
  .popBar {
    display: inline-block;
    width: 4px;
    height: 13px;
    background-color: #327eff;
    border-radius: 2px;
    margin-right: 10px;
  }
  .greBar {
    background-color: #73deb3;
  }
  .popBar{
    background: rgba(193, 133, 246, 0.85);
  }
    .blueColor {
    color: #327eff;
  }
  .fz28 {
    font-size: 28px;
  }
  .fz43 {
    font-size: 43px;
  }
  .fz12 {
    font-size: 12px;
  }
}
</style>